/**
 * Story meta widget 
 * @author Ryan Gladstone
 * <story-meta story="story"></story-meta>
 */

import template from './storyMeta.html';

function storyMeta() {
  return {
    restrict: 'E',
    scope: {
      story: '='
    },
    template,
    controller: ['$scope', '$uibModalStack', ($scope, $uibModalStack) => {
      $scope.close = () => {
        $uibModalStack.dismissAll();
      };
    }]
  };
}

export default function (ngModule) {
  ngModule.directive('storyMeta', storyMeta);
}
